/*jshint esversion: 6 */

jQuery(document).ready(function() {

    const carouselHero = document.getElementById("carouselHero");

    if (carouselHero && carouselHero.childElementCount > 1) {
        jQuery(".carouselHero").owlCarousel({
            items: 1,
            nav: false,
            loop: true,
            dots: true,
            autoplay: true,
            autoplayTimeout: 7000
        });
    }

    jQuery(".carouselFeatured").owlCarousel({
        margin: 30,
        nav: true,
        loop: true,
        dots: false,
        autoWidth: false,
        autoplay: true,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            992: {
                margin: 40,
                items: 3
            },
            1200: {
                margin: 40,
                items: 4
            },
            1600: {
                margin: 60,
                items: 4
            }
        }
    });

    jQuery(".carouselPolaroid").owlCarousel({
        items: 1,
        nav: true,
        loop: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 7000,
        autoplayHoverPause: true
    });


    jQuery(".carouselBrands").owlCarousel({
        margin: 30,
        nav: true,
        loop: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 4
            },
            768: {
                items: 6
            },
            992: {
                items: 8
            }
        }
    });

    jQuery(".carouselRelatedCards").owlCarousel({
        margin: 40,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            1200: {
                items: 2
            }
        }
    });

    jQuery(".carouselPastEvents").owlCarousel({
        margin: 40,
        nav: true,
        dots: false,
        autoplay: false,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            992: {
                items: 3
            },
            1200: {
                items: 4
            }
        }
    });

    if ($('.carouselTestimonials').length > 1) {
        jQuery(".carouselTestimonials").owlCarousel({
            // margin: 40,
            items: 1,
            nav: true,
            loop: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 7000,
            autoplayHoverPause: true
        });
    } else {
        $('.carouselTestimonials').show();
    }

});